export enum ErrorType {
  Unexpected = 'Unexpected',
  CalculationsFailed = 'CalculationsFailed',
  Unknown = 'Unknown'
}

export interface StandardErrorDto {
  errorType: ErrorType;
  message: string;
}

export interface ValidationErrorDto {
  details: Record<string, string[]>;
}

export interface LoadCaseDto {
  loadCaseId: string;
  loadCaseName: string;
}

export interface LoadCaseValidationErrorDto extends LoadCaseDto {
  error: ValidationErrorDto;
}

export interface LoadCaseErrorDto extends LoadCaseDto {
  error: StandardErrorDto;
}

export interface ValidationErrorsDto {
  general?: ValidationErrorDto;
  loadCases: LoadCaseValidationErrorDto[];
}

export interface OtherErrorsDto {
  errorId: string;
  general?: StandardErrorDto;
  loadCases: LoadCaseErrorDto[];
}

export interface PerivisErrorContainerDto {
  validationErrors?: ValidationErrorsDto;
  otherErrors?: OtherErrorsDto;
}

// --- Utility functions / computed properties ---

export function hasOtherErrors(otherErrors?: OtherErrorsDto): boolean {
  return !!otherErrors && (
    !!otherErrors.general || (otherErrors.loadCases?.length ?? 0) > 0
  );
}

export function hasValidationErrors(validationErrors?: ValidationErrorsDto): boolean {
  return !!validationErrors && (
    !!validationErrors.general ||
    (validationErrors.loadCases?.length ?? 0) > 0
  );
}

export function hasErrors(container: PerivisErrorContainerDto): boolean {
  return hasOtherErrors(container?.otherErrors) || hasValidationErrors(container?.validationErrors);
}